import { post } from './http'
import global from '@/api/global'
var name = global.zhb_vas
var driverName = global.driverName
var crm = global.crm
var crmServer3 = '/crm-server3/crm3'
// 获取组织机构
// export const getOrganizationByUserCode = p => post(crmServer3 + '/api/getOrganizationByUserCode', p)
export let getOrganizationByUserCode = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/api/getOrganizationByUserCode`, p)
  } else {
    return post(`${crm}/api/getOrganizationByUserCode`, p)
  }
}
// 用车单位-用车申请添加-用车单位下拉框数据
export const getAllOrgUserTreeData = p => post(name + '/bDictionary/getAllOrgUserTreeData', p)
// 用车单位-用车申请添加-申请车型、单价下拉框
export const getVehicleTypeSelect = p => post(name + '/tUpriceVehicletype/getVehicleTypeSelect', p)
// 用车单位-用车申请添加-工作类型下拉框
export const getDictionaryList = p => post(name + '/bDictionary/getDictionaryList', p)
// 用车单位-申请用车新增保存接口
export const VehicleapplyInfoAdd = p => post(name + '/tVehicleapplyInfo/add', p)
// 用车单位-申请用车修改保存接口
export const VehicleapplyInfoUpdate = p => post(name + '/tVehicleapplyInfo/update', p)
//  用车单位-查询列表
export const tVehicleapplyInfoList = p => post(name + '/tVehicleapplyInfo/list', p)
//  用车单位-撤销
export const revokeApply = p => post(name + '/tVehicleapplyInfo/revokeApply', p)
// 用车单位-申请用车删除
export const applyDelete = p => post(name + '/tVehicleapplyInfo/delete', p)
//  用车单位-详情
export const vhcApplyDetail = p => post(name + '/tVehicleapplyInfo/vhcApplyDetail', p)
// 实时位置
export const getVehicleMonitor = p => post(name + '/tVehicleapplyInfo/getVehicleMonitor', p)
// 历史轨迹
export const getVehicleHistory = p => post(name + '/tVehicleapplyInfo/getVehicleHistory', p)
// 车管员-用车申请-车型下拉框
export const vheTypeList = p => post(driverName + '/type2link/vheTypeList', p)
// 车管员-用车申请-车查询列表
export const applyList = p => post(name + '/vehicle/manager/applyList', p)
// 车管员-用车申请-分配/修改页面-可用车数列表
export const getAvailableFleetCarCount = p => post(name + '/vehicle/manager/getAvailableFleetCarCount', p)
// 车管员-用车申请-分配/修改页面-用车申请已分配的车队信息
export const forManager = (applyId) => post(name + `/vehicle/manager/distributionInfo/forManager/${applyId}`)
// 车管员-用车申请-分配/修改页面-分配/修改保存
export const fleetDistribution = (params, applyId) => post(name + `/vehicle/manager/fleetDistribution/${applyId}`, params)
// 车管员-用车申请-分配/修改页面-删除
export const deleteFleetDistribution = (distributionId) => post(name + `/vehicle/manager/deleteFleetDistribution/${distributionId}`)
// 车型单价-查询条件-计价方式下拉框
export const priceMethodPullDownMenu = p => post(name + '/vehicle/manager/priceMethodPullDownMenu', p)
// 车型单价-查询列表
export const vehicleModelPriceList = p => post(name + '/vehicle/manager/vehicleModelPriceList', p)
// 车型单价-删除
export const managerdDelete = (id) => post(name + `/vehicle/manager/remove/${id}`)
// 车型单价-添加
export const addVehicleModelPrice = p => post(name + '/vehicle/manager/addVehicleModelPrice', p)
// 车型单价-添加-获取某一车型下的所有机型/吨位下拉列表
export const listByTypeId = (typeId) => post(driverName + `/type2link/listByTypeId/${typeId}`)
// 车型单价-通过id获取单价信息主要是为了回显
export const getVehicleModelPrice = (id) => post(name + `/vehicle/manager/getModelPrice/${id}`)
// 车型单价-修改
export const updatePrice = p => post(name + '/vehicle/manager/updatePrice', p)
// 用车费用
export const applyCost = p => post(name + '/vehicle/manager/applyCost', p)

// 用车费用总计
export const totalCost = p => post(name + '/vehicle/manager/totalCost', p)
// 用车费用里面的车型
export const fleetTypeMenu = p => post(name + '/vehicle/manager/fleetTypeMenu')
